<template>
    <div class="card border-light shadow-sm p-3">
        <!-- <pre>{{ permissions }}</pre> -->
        <div style="position: absolute; margin-top: 40px; z-index: 1; width: max-content; left: 50%; transform: translate(-50%, 0%);" v-if="!permissions.find(e => e.permission_name == 'View Quantity Values')">
            <span style="color: red;"><i class="mr-2 fa fa-eye-slash"></i>You dont have the viewing permission.</span>
        </div>
        <div :style="!permissions.find(e => e.permission_name == 'View Quantity Values') ? 'filter: blur(4px); pointer-events: none;' : ''" >
            <div class="row">
                <div class="col-md-6 mb-1">
                    <label for="birthday">Select An Category</label>
                    <MssSelect type="select" v-model="selected_category" :options="category_list" label="category_name" placeholder="Category"></MssSelect>
                </div>
                <div class="col-md-6 mb-1">
                    <label for="birthday">Select A Sub-Category</label>
                    <MssSelect type="select" v-model="selected_sub_category" :options="sub_category_list" label="sub_category_name" placeholder="Sub-Category"></MssSelect>
                </div>
            </div>
            <div class="row" v-if="combination.length > 0 && (selected_category || selected_sub_category)">
                <div class="w-100 d-inline-flex flex-row-reverse">
                    <button :disabled="!permissions.find(e => e.permission_name == 'Save Quantity Values')" class="btn btn-success my-2 mb-3 w-25" @click.prevent="validateTable()">Save All</button>
                </div>
                <div style="max-width: 100%; max-height: 400px; overflow-x: scroll;">
                    <table class="table table-hover">
                        <thead class="thead-light">
                            <th style="max-width: 150px; overflow: hidden; text-overflow: ellipsis;" v-for="(item, index) in option" :key="index" v-if="item.option_value.length > 0">
                                {{ item.name }}
                            </th>
                            <th style="min-width: 150px;">Quantity</th>
                            <th style="min-width: 150px;">Price Per Piece</th>
                            <th style="min-width: 150px;">Exp Delivery Days</th>
                            <th style="min-width: 80px;">status</th>
                            <th style="text-align: center;">Action</th>
                        </thead>
                        <tbody>
                            <!-- <pre>{{ combination }}</pre> -->
                            <tr v-for="(item1, ind) in combination" :key="ind">
                                <td v-for="(item2, i) in option.filter(e => e.option_value.length > 0)" :key="i">{{ item1.combos.find(e => e.opt_id == item2.id) ? item1.combos.find(e => e.opt_id == item2.id).name : 'N/A' }}</td>
                                <td ><input v-model="item1.quantity" placeholder="Quantity" class="form-control py-1" required/></td>
                                <td ><input v-model="item1.price" placeholder="Price" class="form-control py-1" required/></td>
                                <td ><input v-model="item1.exp_day" placeholder="EXP DEL DAYS" class="form-control py-1" required/></td>
                                <td>
                                    <MssInput type="switch" @input="ChangeStatus(item1)" v-model="item1.status"></MssInput>
                                </td>
                                <td >
                                    <button :disabled="!permissions.find(e => e.permission_name == 'Save Quantity Values')" class="btn btn-success mr-1" @click.prevent="validateTable(ind)"><i :class="item1.for_update ? 'fa fa-pencil' : 'fa fa-save'"></i></button>
                                    <button class="btn btn-success mr-1" @click.prevent="addForSameCombo(item1, ind)"><i class="fa fa-copy"></i></button>
                                    <button :class="item1.deleted ? 'btn btn-secondary' : 'btn btn-danger'" v-if="!item1.main" @click.prevent="removeCombo(ind)"><i :class="item1.deleted ? 'fa fa-refresh' : 'fa fa-trash'"></i></button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
export default {
    data() {
        return {
            category_list: [],
            sub_category_list: [],
            option: [],
            option_values: [],
            option_value_types: [],
            selected_category: null,
            selected_sub_category: null,
            combination: [],
            quantity_id: null,
            quantity_option: null,
            quantity_status: null,
            quantity_list: [],
            permissions: null,
        }
    },
    props: ["action"],
    created() {
        if (localStorage.getItem('permissions')) {
            const permissionsLS = localStorage.getItem('permissions')
            const permission = JSON.parse(permissionsLS)
            this.permissions = permission.filter(e => e.section == 'QUANTITY' && e.has_permission == true)
        }
        this.fetchQuantity()
        this.fetchCategory()
        this.fetchSubCategory()
        this.fetchOptionValueTypes()
        // this.fetchOptions()
        // this.fetchOptionValues()
    },
    methods: {
        async ChangeStatus(data) {
            const data_to_update = {
                id: data.id,
                status: data.status
            }
            const response = await axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                data: {
                    ...data_to_update,
                    type: "UpdateQuantityStatus"
                },
            })
            this.$toasted.global[response.data.status]({
                message: response.data.msg
            })
        },
        async deleteAndRestore(id) {
            const data = {
                id,
                type: "deleteAndRestoreQuantityValue"
            }
            const response = await axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                data,
            })
            this.$toasted.global[response.data.status]({
                message: response.data.msg
            })
            if (this.selected_sub_category) {
                this.fetchQuantity()
                this.combination = []
                this.fetchOptions(this.selected_sub_category.cat_id ? this.selected_sub_category.cat_id : null, this.selected_sub_category ? this.selected_sub_category.id : null)
            } else if (this.selected_category) {
                this.fetchQuantity()
                this.combination = []
                this.fetchOptions(this.selected_category ? this.selected_category.id : null, null)
            }
        },
        async fetchQuantity(q_id = null, q_opt = null, q_status = null) {
            const data = {
                type: "fetchQuantityValues"
            }
            if(q_opt) {
                data['quantity_option_combo'] = q_opt
            }
            if(q_id) {
                data['quantity_id'] = q_id
            }
            if(q_status) {
                data['status'] = q_status
            }
            const response = await axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                data,
            })
            this.quantity_list = response.data.data
        },
        async addQuantityValue(data) {
            if (data.length == 1) {
                const response = await axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                    data: {
                        data_array: data,
                        type: "saveQuantityValue"
                    },
                })
                this.$toasted.global[response.data.status]({
                    message: response.data.msg
                })
            } else {
                const data_array = data
                const response = await axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                    data: {
                        data_array,
                        type: "saveQuantityValue"
                    },
                })
                this.$toasted.global[response.data.status]({
                    message: response.data.msg
                })
            }
            if (this.selected_sub_category) {
                this.fetchQuantity()
                this.combination = []
                this.fetchOptions(this.selected_sub_category.cat_id ? this.selected_sub_category.cat_id : null, this.selected_sub_category ? this.selected_sub_category.id : null)
            } else if (this.selected_category) {
                this.fetchQuantity()
                this.combination = []
                this.fetchOptions(this.selected_category ? this.selected_category.id : null, null)
            }
        },
        validateTable(index = null) {
            let error = false
            let data = []
            if (index !== null) {
                if (!this.combination[index].quantity) {
                    error = true
                }
                if (!this.combination[index].price) {
                    error = true
                }
                data = [this.combination[index]]
            } else {
                this.combination.forEach(e => {
                    if( !e.quantity ) {
                        error = true
                    }
                    if ( !e.price ) {
                        error = true
                    }
                })
                data = this.combination
            }
            if (error) {
                this.$toasted.global.error({
                    message: 'Please fill all the quantity and price fields.'
                })
                return
            }
            this.customizeData(data)
        },
        customizeData(ary) {
            const data = []
            ary.forEach(e => {
                let element = e.id ? {
                    id: e.id,
                    quantity_option_combo: e.combo_short,
                    quantity: e.quantity,
                    status: e.status,
                    price_per_piece: e.price,
                    expected_delivery_in_days: e.exp_day
                } : {
                    quantity_option_combo: e.combo_short,
                    quantity: e.quantity,
                    status: e.status,
                    price_per_piece: e.price,
                    expected_delivery_in_days: e.exp_day
                }
                data.push(element)
            })
            this.addQuantityValue(data)
        },
        removeCombo(i) {
            const data = this.combination[i] 
            if (data.id) {
                this.deleteAndRestore(data.id)
            } else {
                this.combination.splice(i, 1)
            }
        },
        addForSameCombo(combo, index) {
            const newCombo = {
                combos: combo.combos,
                for_update: false,
                combo_short: combo.combo_short,
                status: false,
                quantity: '',
                price: '',
                main: false
            }
            this.combination.splice(index + 1, 0, newCombo);
        },
        findCombinations(options) {
            const array = options.map(e => e.option_value ? e.option_value : null).filter(e => e.length > 0)
            options = array
            const combinations = [];
            function backtrack(currentIndex, currentCombination) {
                // Base case: If we have processed all options, add the current combination to the result
                if (currentIndex === options.length) {
                    combinations.push(currentCombination.slice());
                    return;
                }
                const currentOptions = options[currentIndex];
                // Iterate over each value in the current options
                for (let i = 0; i < currentOptions.length; i++) {
                    const value = currentOptions[i];
                    // Add the current value to the combination
                    currentCombination.push(value);
                    // Recursively generate combinations for the remaining options
                    backtrack(currentIndex + 1, currentCombination);
                    // Remove the last added value to try the next one
                    currentCombination.pop();
                }
            }
            // Start the backtracking process
            backtrack(0, []);
            this.combination = []
            combinations.forEach(e => {
                const combo = JSON.stringify(e.map(e => e.id))
                // console.log(this.quantity_list.filter(e => e.options_combo == combo || JSON.parse(combo).every(elem => JSON.parse(e.options_combo).includes(elem))));
                const availableSameCombo = this.quantity_list.filter(e => e.options_combo == combo)
                const availableSimilarCombo = this.quantity_list.filter(e => JSON.parse(e.options_combo).every(elem => JSON.parse(combo).includes(elem)))
                if (availableSimilarCombo.length > 0) {
                    availableSimilarCombo.forEach((elm, index) => {
                        if (this.combination.filter(e => e.id == elm.id).length == 0) {
                            this.combination.push({
                                id: elm.id,
                                combos: e.filter(e => JSON.parse(elm.options_combo).includes(e.id)),
                                main: index == 0 ? true : false,
                                for_update: true,
                                combo_short: elm.options_combo,
                                deleted: elm ? elm.deleted : false,
                                status: elm ? elm.status : false,
                                quantity: elm ? elm.quantity : '',
                                price: elm ? elm.price_per_piece : '',
                                exp_day: elm ? elm.expected_delivery_in_days : '',
                            });
                        }
                    })
                }
                if (availableSameCombo.length >= 1) {
                    availableSameCombo.forEach((element, index) => {
                        if (this.combination.filter(e => e.id == element.id).length == 0) {
                            this.combination.push({
                                id: element.id,
                                combos: e,
                                main: index == 0 ? true : false,
                                combo_short: combo,
                                for_update: true,
                                deleted: element ? element.deleted : false,
                                status: element ? element.status : false,
                                quantity: element ? element.quantity : '',
                                price: element ? element.price_per_piece : '',
                                exp_day: element ? element.expected_delivery_in_days : '',
                            })
                        }
                    })
                } else {
                    this.combination.push({
                        combos: e,
                        main: true,
                        for_update: false,
                        deleted: false,
                        combo_short: combo,
                        status: false,
                        quantity: '',
                        price: '',
                        exp_day: ''
                    })
                }
            })
            // console.log(this.combination);
        },
        async fetchOptionValues(id = null) {
            const params = id ? {
                opt_id: id,
                type: 'fetchOptionValues'
            } : {
                type: 'fetchOptionValues'
            }
            const response = await axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                data: params
            })
            return response.data.data
        },
        async fetchOptions(cat_id = null, sub_cat_id = null) {
            const params = {
                type: 'fetchOptions'
            }
            if (cat_id) {
                params['cat_id'] = cat_id
            }
            if (sub_cat_id) {
                params['sub_cat_id'] = sub_cat_id
            }
            const response = await axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                data: params
            })
            this.option_values = []
            const options = await response.data.data.map(async (e) => {
                const option_value = await this.fetchOptionValues(e.id)
                this.option_values.push(...option_value)
                return {
                    ...e,
                    option_value
                }
            })
            this.option = await Promise.all(options)
            this.findCombinations(this.option)
        },
        async fetchOptionValueTypes() {
            const params = {
                type: 'fetchAllValueTypes'
            }
            const response = await axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                params
            })
            this.option_value_types = response.data.data
        },
        async fetchSubCategory(cat_id = null) {
            const response = await axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                data: cat_id ? {
                    type: 'fetchSubCategory',
                    cat_id
                } :{
                    type: 'fetchSubCategory',
                }
            })  
            this.sub_category_list = response.data.data
        },
        async fetchCategory() {
            const response = await axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                data: {
                    type: 'fetchAllCategories',
                }
            })
            this.category_list = response.data.data
        },
    },
    watch: {
        selected_category(val) {
            if (val) {
                this.combination = []
                this.fetchSubCategory(val.id)
                this.fetchOptions(val ? val.id : null, this.selected_sub_category ? this.selected_sub_category.id : null)
            } else {
                this.combination = []
                this.fetchSubCategory()
                this.fetchOptions(this.selected_sub_category ? this.selected_sub_category.cat_id : null, this.selected_sub_category ? this.selected_sub_category.id : null)
            }
        },
        selected_sub_category(val) {
            if (val) {
                this.combination = []
                this.fetchOptions(val.cat_id ? val.cat_id : null, val ? val.id : null)
            } else {
                this.combination = []
                this.fetchOptions(this.selected_category ? this.selected_category.id : null, null)
            }
        },
    }
}
</script>